import { SortDirection } from '../entities/sort-direction.entity';
import { defaultSortInfo, SortInfo } from '../entities/sort-info.entity';

export function getSortDirection(direction: string): SortDirection {
    switch (direction.toLowerCase()) {
        case 'desc':
        case 'down':
            return SortDirection.DESC;

        case 'asc':
        case 'up':
            return SortDirection.ASC;

        default:
            return SortDirection.DESC;
    }
}

export function createSortInfo(field: string, direction: string): SortInfo {
    return {
        field,
        direction: getSortDirection(direction)
    };
}

export function sortInfoToString(sortInfo: SortInfo): string {
    return `${sortInfo.field}-${sortInfo.direction}`;
}

export function parseSortInfo(sortKey: string): SortInfo {
    const terms = sortKey.split('-');

    if (terms.length === 0 || terms.length > 2) {
        console.error(`Error converting key ${sortKey} to sort settings . Falling back to default.`);
        return defaultSortInfo;
    }

    const field = terms[0];
    const direction = terms.length === 2 ? getSortDirection(terms[1]) : SortDirection.ASC;

    return {
        field,
        direction
    };
}
